"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetDetailImage = AssetDetailImage;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const get_cdn_image_url_1 = require("@src/shared/get-cdn-image-url");
const AssetDetailImage_style_1 = require("./AssetDetailImage.style");
function AssetDetailImage({ asset }) {
    const assetImageUrl = (0, get_cdn_image_url_1.getCdnImageUrl)({
        file: asset.cloudinaryPublicId,
        shouldIncludeEnvironmentPart: false,
        addWatermarkedLogo: true,
    });
    return ((0, jsx_runtime_1.jsx)(AssetDetailImage_style_1.AssetDetailImageContainer, { children: (0, jsx_runtime_1.jsx)(AssetDetailImage_style_1.AssetDetailImg, { src: assetImageUrl, alt: "asset-detail-img" }) }));
}
